import styled from 'styled-components';
export const NavBack = styled.div.withConfig({
  displayName: "Nav__NavBack",
  componentId: "sc-r4q5b5-0"
})(["display:flex;position:relative;padding:14px 18px 14px 12px;margin-bottom:12px;&:after{display:block;position:absolute;bottom:0;left:0;right:0;height:1px;margin:0 16px;content:'';background-color:", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.terciaryL;
});